// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.villas {
  overflow-x: hidden;
}

.villas .heroSkeleton,
.villas .hero {
  margin-top: unset !important;
}

.villas__container {
  margin: 5rem auto 7rem auto;
  display: grid;
  gap: 3rem;
  grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
}

.pagination-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 1rem;
  margin: 0 auto;
}

.pagination-nav button {
  display: grid;
  place-items: center;
  background-color: var(--clr-brown);
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
}

.pagination-bullets {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.pagination-bullet.active {
  width: 1rem;
  border-radius: 3em;
  background: var(--clr-gray500);
}

.pagination-bullet {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  cursor: pointer;
  background: var(--clr-gray600);
}

.villas__search {
  position: relative;
  z-index: 10;
}

.villas__btnReset {
  margin-top: 2rem;
  border-radius: 1em;
}

@media (min-width: 768px) {
  .villas__container {
    grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
  }

  .villas__search {
    margin-top: -5rem;
  }
}

@media (min-width: 992px) {
  .villas {
    overflow-x: unset;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Villas/Villas.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,aAAa;EACb,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,4DAA4D;EAC9D;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".villas {\n  overflow-x: hidden;\n}\n\n.villas .heroSkeleton,\n.villas .hero {\n  margin-top: unset !important;\n}\n\n.villas__container {\n  margin: 5rem auto 7rem auto;\n  display: grid;\n  gap: 3rem;\n  grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));\n}\n\n.pagination-nav {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  gap: 1rem;\n  margin: 0 auto;\n}\n\n.pagination-nav button {\n  display: grid;\n  place-items: center;\n  background-color: var(--clr-brown);\n  width: 2.5rem;\n  height: 2.5rem;\n  padding: 0;\n}\n\n.pagination-bullets {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.pagination-bullet.active {\n  width: 1rem;\n  border-radius: 3em;\n  background: var(--clr-gray500);\n}\n\n.pagination-bullet {\n  width: 0.5rem;\n  height: 0.5rem;\n  border-radius: 50%;\n  cursor: pointer;\n  background: var(--clr-gray600);\n}\n\n.villas__search {\n  position: relative;\n  z-index: 10;\n}\n\n.villas__btnReset {\n  margin-top: 2rem;\n  border-radius: 1em;\n}\n\n@media (min-width: 768px) {\n  .villas__container {\n    grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));\n  }\n\n  .villas__search {\n    margin-top: -5rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .villas {\n    overflow-x: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
